"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-weight: 700;\n  margin: ", "px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  width: 12px;\n  height: 12px;\n  background-color: ", ";\n  margin-right: ", "px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-left: ", "px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  height: ", "px;\n  width: ", "px;\n  position: relative;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  flex-direction: column;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

exports.Wrapper = styled_components_1["default"].div(_templateObject());
exports.Label = styled_components_1["default"].div(_templateObject2());
exports.ChartWrapper = styled_components_1["default"].div(_templateObject3(), function (_ref) {
  var size = _ref.size;
  return size;
}, function (_ref2) {
  var size = _ref2.size;
  return size;
});
exports.Legend = styled_components_1["default"].div(_templateObject4(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing.unit * 4;
});
exports.LegendCircle = styled_components_1["default"].div(_templateObject5(), function (_ref4) {
  var _ref4$color = _ref4.color,
      color = _ref4$color === void 0 ? null : _ref4$color;
  return color === null ? "unset" : color;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.spacing.unit * 2;
});
exports.LegendItem = styled_components_1["default"].div(_templateObject6(), function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing.unit;
});